import { Title } from '@components/styled/Title.styled';
import styled from 'styled-components';
import { fontHeadingSm } from '../../typography.styled';

export const TitleGroup = styled.div`
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    flex-wrap: nowrap;
    column-gap: 10px;

    ${Title} {
        ${fontHeadingSm}
        text-align: left;
    }
`;
